import { createSlice } from '@reduxjs/toolkit'
import { UpdateEntityState } from '../types/updateEntity.type'

const initialState: UpdateEntityState = {
  entityData: null,
}

const updateEntitySlice = createSlice({
  name: 'updateEntity',
  initialState,
  reducers: {
    setEntityDataForUsResident: (state: UpdateEntityState, action) => {
      if (!state.entityData) {
        state.entityData = {}
      }

      const { key, value } = action.payload
      if (key) {
        state.entityData[key] = value
      }
    },
    clearEntityDataForUsResident: (state) => {
      state.entityData = null
    },
  },
})

export const { setEntityDataForUsResident, clearEntityDataForUsResident } =
  updateEntitySlice.actions
export default updateEntitySlice.reducer
